module.exports = __webpack_public_path__ + "img/_homepage.c90c2c80.jpg";